<template>
  <div>
    <main class="l-content">
      <section class="l-section wpb_row height_small mpc-row restore-password">
        <div @keypress.enter="onRestore"
             class="l-section-h restore-password__inner">
          <h1 class="restore-password__title">{{$t("Введіть новий пароль")}}</h1>
          <div class="restore-password__content">
            <BaseInput v-model="inputs.password.value"
                       :placeholder="$t('Пароль')"
                       :error="inputs.password.error"
                       type="password"
                       class="restore-password__input"
            />
            <BaseInput v-model="inputs.password_repeat.value"
                       :placeholder="$t('Повторіть пароль')"
                       :error="inputs.password_repeat.error"
                       type="password"
                       class="restore-password__input"
            />
            <BaseAlertInline :value="overallErrorsMix"
                             class="_warning"
            />
            <button @click.prevent="onRestore"
                    class="restore-password__btn base-btn">{{$t("Змінити пароль")}}</button>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
  import formMixins from '../mixins/formMixins'

  export default {
    mixins: [formMixins],
    data() {
      return {
        inputs: {
          password: {
            value: null
          },
          password_repeat: {
            value: null
          }
        }
      }
    },
    computed: {
      token() {
        return this.$route.query.token
      }
    },
    methods: {
      onRestore() {
        this.resetErrorsMix(this.inputs)

        const sendData = this.createSendDataMix(this.inputs)
        sendData.password_reset_token = this.token

        this.$store.dispatch('user/restorePassword', sendData).then((data) => {
          this.$router.push({name: 'home'})
          this.$nextTick(() => {
            this.$vModal.open('message', {
              title: data.message,
              type: data.status,
              buttonText: this.$t('Вхід'),
              callBack: () => {
                this.$vModal.open('auth-login')
              }
            })
          })
        }).catch(e => {
          this.handlerErrorMix(e, this.inputs)
        })
      }
    }
  }
</script>

<style lang="less">

</style>
